export default {"src":"/_next/static/media/ic-facebook.70096487.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};